import { render, staticRenderFns } from "./InputBox1.vue?vue&type=template&id=b45ea8ea&scoped=true"
import script from "./InputBox1.vue?vue&type=script&lang=js"
export * from "./InputBox1.vue?vue&type=script&lang=js"
import style0 from "./InputBox1.vue?vue&type=style&index=0&id=b45ea8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45ea8ea",
  null
  
)

export default component.exports